import * as React from 'react';
import { cn } from '@relay-towing/tokens';
import {
  controlSlotRecipe,
  type ControlSlotRecipeProps,
} from '../recipes/control-slot.recipe';
import { inputRecipe, type InputRecipeProps } from '../recipes/input.recipe';

export interface ControlSlotProps
  extends React.HTMLAttributes<HTMLDivElement>,
    ControlSlotRecipeProps {
  /** Input's size scale, so the slot is as tall as the fields beside it. */
  size?: InputRecipeProps['size'];
  /** Draw the invalid state — the red border — as an Input would. */
  invalid?: boolean;
}

/**
 * A box drawn like an Input, for a field the library does not render — a
 * payment provider's card element, mounted by its own SDK.
 *
 *   const mountRef = useRef<HTMLDivElement>(null);
 *   useEffect(() => { card.mount(mountRef.current!) }, []);
 *   <ControlSlot ref={mountRef} size="md" invalid={!!cardError} />
 *
 * The ref is the div itself, which is what a mount call wants. Nothing is
 * rendered inside it: the third party fills it.
 */
export const ControlSlot = React.forwardRef<HTMLDivElement, ControlSlotProps>(
  function ControlSlot(
    { size = 'md', grow, invalid, className, ...props },
    ref
  ) {
    return (
      <div
        ref={ref}
        aria-invalid={invalid || undefined}
        className={cn(
          inputRecipe({ size }),
          controlSlotRecipe({ grow }),
          className
        )}
        {...props}
      />
    );
  }
);
